/** How a brand draws its rating questions. Both styles submit the same 1-5 number. */
export type RatingIcon = 'Star' | 'Emoji';

/**
 * The brand's choice, from whatever the campaign carried.
 *
 * ANYTHING THAT IS NOT EMOJI IS A STAR — absent, unrecognised, or a value added after this build shipped.
 * Star is the documented default, so an app talking to an API that predates the field draws what a brand
 * that never chose would get, rather than guessing from its own history.
 *
 * Case-insensitive: the value crosses a proto enum and three APIs on its way here, and none of them promises
 * a casing.
 */
export function ratingIconFrom(value: string | null | undefined): RatingIcon {
    return value?.toLowerCase() === 'emoji' ? 'Emoji' : 'Star';
}
